import { getCategoryIds } from '../../common/selectors/categories-selectors';
import { normalizePost } from '../../common/services/post-utils';
import { createPromisifiedAction } from '../../common/actions-promisifier/create-promisified-action';

export const ENABLE_POST_COMMENTS_REQUEST = 'post/ENABLE_COMMENTS_REQUEST';
export const ENABLE_POST_COMMENTS_SUCCESS = 'post/ENABLE_COMMENTS_SUCCESS';
export const ENABLE_POST_COMMENTS_FAILURE = 'post/ENABLE_COMMENTS_FAILURE';

export function enablePostComments(id) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: ENABLE_POST_COMMENTS_REQUEST,
    });

    const promise = request.post(`/_api/posts/${id}/enableComments`);

    return promise
      .then(post =>
        dispatch({
          type: ENABLE_POST_COMMENTS_SUCCESS,
          payload: normalizePost({ post, blogCategoryIds: getCategoryIds(getState()) }),
        }),
      )
      .catch(() =>
        dispatch({
          type: ENABLE_POST_COMMENTS_FAILURE,
        }),
      )
      .then(() => promise);
  };
}

export const enablePostCommentsPromisified = createPromisifiedAction(
  enablePostComments,
  data => data,
  response => response.status,
);
